




























import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import MemberApi from '@/apis/MemberApi';

@Component({
        name: 'MemberDelete',
    },
)
export default class MemberDelete extends ViewBase {

    public confirmDelete: boolean = false;

    public confirmDeleteRules(value: boolean): any {
        if ( !value )
        {
            return 'Please confirm that you want to delete your membership.';
        }

        return true;
    }

    public async deleteClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const api = new MemberApi();
                const response = await api.deleteAsync(this.$store.state.member.jwt);

                this.$store.dispatch('signOut');
                this.$store.commit('mutateSnackbarText', 'Your membership has been deleted.  Thank you for using CashTamer.com.');
                this.$store.commit('mutateShowSnackbar', true);
                await this.$router.push({name: 'home'});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.memberDeleteForm;

        return form.validate();
    }

}

